
import type { MetaInfo } from 'vue-meta';

import AdUnit from '@/components/AdUnit.vue';
import GuideFeatured from '@/components/editorial/GuideFeatured.vue';
import GuideItem from '@/components/editorial/GuideItem.vue';
import PaginationNav from '@/components/nav/PaginationNav.vue';

import { usePagination } from '@/helpers/composables/usePagination';
import { useArticleList } from '@/helpers/composables/useArticleList';

import { makeRssMetaInfo } from '@/routing/editorial';

import { ClickGuideItemLink, clickGuideItemLink } from '@/pages/editorial/tracking';
import { useLanguageStore } from '@/helpers/composables/useStores';

export default {
	components: {
		AdUnit,
		GuideFeatured,
		GuideItem,
		PaginationNav,
	},
	metaInfo(): MetaInfo {
		// @ts-ignore ts doesn't understand this
		const { $route, $t } = this;
		const t = $t.bind(this);

		const page = +$route.query?.page;
		const isOnPage = !Number.isNaN(page) && page > 1;

		const title = (
			isOnPage ? t('WEBAPP_GUIDE_META_TITLE_PAGED', { page }) : t('WEBAPP_GUIDE_META_TITLE')
		).toString();

		const description = (
			isOnPage ? t('WEBAPP_GUIDE_META_DESCRIPTION_PAGED', { page }) : t('WEBAPP_GUIDE_META_DESCRIPTION')
		).toString();

		const canonicalPath = `https://www.${JW_CONFIG.DOMAIN}${$route.fullPath}`;

		const { meta, link } = makeRssMetaInfo();

		return {
			title,
			link: [{ vmid: 'canonical', rel: 'canonical', href: canonicalPath }, ...link],
			meta: [
				{ vmid: 'description', name: 'description', content: description },
				{ vmid: 'og:title', property: 'og:title', content: title },
				{ vmid: 'og:description', property: 'og:description', content: description },
				...meta,
			],
		};
	},
	setup() {
		// TODO Remove when BE fix issue with deleted title
		const { country } = useLanguageStore();
		const shouldRenderPagination = country.value !== 'US';
		const pageSize = shouldRenderPagination ? 50 : 40;
		const FEATURED_AMOUNT = 4 as const;

		// how many ad breaks to include in the article list for pages > 1
		const adFrequency = 1;

		const { currentPage, isFirstPage } = usePagination();
		const { articles, lastPage, totalCount } = useArticleList({ pageSize, page: currentPage });

		function trackContentClick(event: { label: string; property: ClickGuideItemLink['property'] }, value: number) {
			clickGuideItemLink({ property: event.property, label: event.label, value });
		}

		return {
			pageSize,
			shouldRenderPagination,
			adFrequency,
			FEATURED_AMOUNT,

			currentPage,
			isFirstPage,

			articles,
			lastPage,
			totalCount,

			trackContentClick,
		};
	},
};
